import { useState } from "react";
import { Modal, ModalBody, Button } from "reactstrap";

import { useTranslation } from "react-i18next";

const N1coInfoModal = () => {
  const [showModal, setShowModal] = useState(false);
  const [currentStep, setCurrentStep] = useState(0);

  const { t } = useTranslation("common");

  const tutorialSteps = [
    {
      image: t("n1coModalTab1Image"),
      text: t("n1coModalTab1Text"),
    },
    {
      image: t("n1coModalTab2Image"),
      text: t("n1coModalTab2Text"),
    },
    {
      image: t("n1coModalTab3Image"),
      text: t("n1coModalTab3Text"),
    },
		{
      image: t("n1coModalTab4Image"),
      text: t("n1coModalTab4Text"),
    }
  ];

	const toggleModal = () => {
		setShowModal(!showModal);
	};

	const closeModal = () => {
		setShowModal(false);
		setTimeout(() => {
    	setCurrentStep(0);
  	}, 500);
	};

  return (
		<>
		<button onClick={toggleModal} className="primaryBtn" style={{ marginRight: "0.5rem" }}>
      INFO
    </button>
    <Modal isOpen={showModal} backdrop="static">
      <ModalBody style={{ padding: 0 }}>
        <img
          src={tutorialSteps[currentStep].image}
          alt={`tutorial-step-${currentStep + 1}`}
          style={{ width: "100%", borderRadius: 12, borderBottomLeftRadius: 0, borderBottomRightRadius: 0 }}
        />
        <p style={{ textAlign: "center", marginTop: "1rem", paddingLeft: '1rem', paddingRight: '1rem', whiteSpace: 'pre-line' }}>
          {tutorialSteps[currentStep].text}
        </p>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            marginTop: "1rem",
            padding: "1rem",
          }}
        >
          {currentStep === 0 ? (
            <Button
              onClick={() => setCurrentStep((prev) => prev + 1)}
              className="primaryBtn"
            >
              {t("next").toUpperCase()}
            </Button>
          ) : (
            <>
              <Button
                disabled={currentStep === 0}
                onClick={() => setCurrentStep((prev) => prev - 1)}
                className="secondaryBtn"
                style={{ color: "#005EE1", width: "49%" }}
              >
                {t("back").toUpperCase()}
              </Button>

              {currentStep < tutorialSteps.length - 1 ? (
                <Button
                  onClick={() => setCurrentStep((prev) => prev + 1)}
                  className="primaryBtn"
                  style={{ width: "49%" }}
                >
                  {t("next").toUpperCase()}
                </Button>
              ) : (
                <Button
                  onClick={closeModal}
                  className="primaryBtn"
                  style={{ width: "49%" }}
                >
                  {t("close").toUpperCase()}
                </Button>
              )}
            </>
          )}
        </div>
      </ModalBody>
    </Modal>
		</>
  );
};

export default N1coInfoModal;